import { useState } from 'react'
import { format } from 'date-fns'

import { DATE_DEBUG_FORMAT, MINUTE, SECOND } from '../../../constants/date'
import { useDate } from '../../../hooks'
import { Container } from '../Container'
import { Controls, controls, radioGroup } from '../Controls'
import { DateTimeProviderProps } from '../DateTime'

function UseDateExample() {
  const [args, setArgs] = useState(() =>
    controls() //
      .add(radioGroup('timeout', SECOND, { options: [SECOND, MINUTE] }))
  )

  const date = useDate(args.getValues().timeout)

  return (
    <>
      <Container label='const date = useDate(timeout)'>
        {format(date, DATE_DEBUG_FORMAT)}
      </Container>
      <Controls value={args} onChange={setArgs} />
    </>
  )
}

export function UseDate() {
  return (
    <DateTimeProviderProps>
      <UseDateExample />
    </DateTimeProviderProps>
  )
}
